import http from '@/api/common'

export default {
  getCalibrationHomepageMessage() {
    return http.get('NotificationMessage/GetWelcomeNotificationMessage')
  },
  getTranslatedCalibrationHomepageMessage(languageCode) {
    return http.get(`NotificationMessage/GetTranslatedCalibrationWelcomeMessage?languageCode=${languageCode}`)
  },
  saveCalibrationHomepageMessage(message) {
    return http.post('NotificationMessage/SaveCalibrationWelcomeMessage', message)
  },
  enableCalibrationHomepageMessage() {
    return http.post('NotificationMessage/EnableCalibrationWelcomeMessage')
  },
  disableCalibrationHomepageMessage() {
    return http.post('NotificationMessage/DisableCalibrationWelcomeMessage')
  }
}



// WEBPACK FOOTER //
// ./src/api/endpoints/calibrationHomepageMessage.js